module.exports = __webpack_public_path__ + "static/media/myFiles-deleted.6407276e.gif";